import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const BuildInfo = () => {
    const data = useStaticQuery(graphql`
  query {
    currentBuildDate {
      currentDate
    }
  }
`);

const buildDateTime = data.currentBuildDate.currentDate;
    return (
        <div style={{textAlign: 'center', backgroundColor: '#30415b', paddingBottom: '16px' }}>
            <p style={{color: '#fcfcfc'}}>Build Date: {buildDateTime}</p>
        </div>    
    );
};

export default BuildInfo;